'use client';

import React, { FC, JSX } from 'react';
import { useMediaQuery, MEDIAQUERY_DEFAULTS } from '@ibe/components';
import sanitize from '@/Util/sanitize';
import { ApiPriceInformation } from '../../../api/model';

const DEFAULT_GRID_COLUMN_BREAK_AMOUNT = 1000;

const SinglePriceInfo: FC<{ singlePriceInformation: ApiPriceInformation }> = ({
  singlePriceInformation
}): JSX.Element => {
  const isDesktop = useMediaQuery(`(min-width: ${MEDIAQUERY_DEFAULTS.lg}px)`, true);

  return (
    <>
      {singlePriceInformation.body &&
        (singlePriceInformation.body?.length >
          (!!singlePriceInformation.charsAmountForColumnBreak &&
          !Number.isNaN(parseInt(singlePriceInformation.charsAmountForColumnBreak, 10))
            ? parseInt(singlePriceInformation.charsAmountForColumnBreak, 10)
            : DEFAULT_GRID_COLUMN_BREAK_AMOUNT) && isDesktop ? (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitize(singlePriceInformation.body, true)
            }}
            className="price-information__body grid-col-9"
          />
        ) : (
          <div className="grid-col-12 grid-col-lg-9 grid">
            <div
              className="price-information__body--unwrapped grid-col-12 grid-col-lg-6"
              dangerouslySetInnerHTML={{
                __html: sanitize(singlePriceInformation.body, true)
              }}
            />
          </div>
        ))}
    </>
  );
};

export default SinglePriceInfo;
